import { render, staticRenderFns } from "./lp-switcher.vue?vue&type=template&id=fd80a97e&scoped=true&lang=pug&"
import script from "./lp-switcher.vue?vue&type=script&lang=js&"
export * from "./lp-switcher.vue?vue&type=script&lang=js&"
import style0 from "./lp-switcher.vue?vue&type=style&index=0&id=fd80a97e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd80a97e",
  null
  
)

export default component.exports